<template>
    <div>
        <action-bar>
        </action-bar>
        <main class="content">
            <div v-if="infobox !== false">
                <h1>Infobox bearbeiten<br>
                    <small class="text-muted">{{infobox.name.text}}</small>
                </h1>
                <text-input :value="infobox.name" label="Name" ref="name"></text-input>
                <long-text-input :value="infobox.description" label="Text" ref="description"></long-text-input>
                <div class="admin-info">
                    <ul>
                        <li>
                            Der Titel der Infobox wird immer als solcher in der Infobox als Titel angezeigt (als Titel dritten Grades). Er muss
                            also nicht im Text wiederholt werden.
                        </li>
                        <li>
                            Für die Zwischentitel entsprechend bitte immer den vierten Überschriftsgrad (#### Überschrift) verwenden.
                        </li>
                        <li>
                            Diese Infobox kann mit dem Code <b>[infobox id={{infobox.id}} align=[left|right]
                            size=[1|2|3]]</b> eingebunden werden.
                            Das [left|right] sowie das [1|2|3] ist jeweils ohne eckige Klammern durch einer der Werte zu
                            ersetzen.
                        </li>
                    </ul>
                </div>
                <hr>
                <button class="btn btn-primary" @click="save">Save</button>
            </div>
            <loading v-else></loading>
        </main>
    </div>
</template>
<script>
  export default {
    data () {
      return {
        infobox: false
      }
    },
    mounted () {
      axios
        .get('/api/' + store.state.language + '/infobox/' + this.$route.params.infoboxId)
        .then(({data}) => {
          this.infobox = data.result
        })
    },
    methods: {
      save () {
        this.$refs.name.save()
        this.$refs.description.save()
        this.$refs.longDescription.save()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/admin/infobox/Edit.vue